import React from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/track-payment");
  };

  return (
    <div className="flex items-start gap-3 justify-start min-h-screen bg-gray-100">
      <div>
        <button
          onClick={handleNavigate}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
        >
          Go to Track Payment
        </button>
      </div>
      <div>
        <button
          onClick={() => navigate("/create-contract")}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
        >
          Create contract
        </button>
      </div>
    </div>
  );
};

export default Home;
